module.exports = __webpack_public_path__ + "img/stock6.e88f89eb.png";